import React from "react";
import {BrowserRouter as Router, Routes, Route,} from 'react-router-dom';
import { Helmet } from "react-helmet";
// Screens
import Landing from "./screens/Landing.jsx";
import 'bootstrap/dist/css/bootstrap.css';
import Posts from "./screens/Posts.jsx";
import Post from "./screens/Post.jsx";
import FAQs from "./components/Sections/FAQs.jsx";
import NoInternet from "./services/NoInternet.js";
import Terms from "./screens/policies/Terms.jsx"
import PrivacyPolicy from "./screens/policies/PrivacyPolicy.jsx"
import Contact from "./components/Sections/Contact.jsx";
import PricingCardsPage from "./components/Sections/PricingCardPage.jsx";
import  CheckoutForm  from "./components/Sections/CheckoutForm.jsx";
import PaymentPage from "./components/Sections/PaymentPage.jsx";
import PaymentCancelled from "./components/Sections/PaymentCancelled.jsx";
import PaymentFailure from "./components/Sections/PaymentFailure.jsx";
import PaymentSuccess from "./components/Sections/PaymentSuccess.jsx";
import RequestDemoPage from "./screens/RequestDemoPage.jsx";
import TrialThankYouPage from "./components/Sections/TrialThankYouPage.jsx";
import MpesaCheckout from "./components/Sections/MpesaChackout.js";
import WaitingMpesa from "./components/Sections/WaitingMpesa.jsx";
import WaitingPayment from "./components/Sections/WaitingPayment.jsx";
import PaymentOptions from "./components/Sections/PaymentOptions.jsx";
import RenewSubscription from "./components/Sections/RenewSubscription.jsx";




function App() {

  return(

    <NoInternet>
      <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link href="https://fonts.googleapis.com/css2?family=Khula:wght@400;600;800&display=swap" rel="stylesheet" />
      </Helmet>
     
      <Router>
       
      <Routes>
      <Route exact path="*" element={<Landing/>}/>
      <Route exact path="/" element={<Landing/>}/>
     <Route exact path="/blog" element={<Posts/>}/>
     <Route exact path="/blog/:slug/:id" element={<Post/>}/>
     <Route exact path="/faqs" element={<FAQs/>}/>
    <Route path="/pricing/:edition" element={<PricingCardsPage />} />
    < Route exact path="/contact-us" element={<Contact/>}/>
     <Route exact path="/checkout" element={<CheckoutForm/>}/>
    <Route exact path="/trial-thank-page" element={<TrialThankYouPage/>}/>
    <Route exact path="/payment" element={<PaymentPage/>}/>
    <Route exact path="/payment-options" element={<PaymentOptions/>}/>
    <Route exact path="/checkout/mpesa" element={<MpesaCheckout/>}/>
    <Route exact path="/waiting-mpesa" element={<WaitingMpesa/>}/>
    <Route exact path="/waiting-payment" element={<WaitingPayment/>}/>
    <Route path="/payment-success" element={<PaymentSuccess />} />
    <Route path="/payment-failure" element={<PaymentFailure />} />
   <Route path="/payment-cancelled" element={<PaymentCancelled />} />
   <Route path="/request-demo" element={<RequestDemoPage />} />
   <Route path="/renew/:invoice" element={<RenewSubscription />} />
     <Route exact path="/terms" element={<Terms/>}/>
     <Route exact path="/privacy" element={<PrivacyPolicy/>}/>

       

      
      </Routes>
  
    </Router>
      
      
      </>


    </NoInternet>

  );

  
 
}

export default App;

